import { render, staticRenderFns } from "./IconSvgIdea.vue?vue&type=template&id=06d161de&scoped=true&"
import script from "./IconSvgIdea.vue?vue&type=script&lang=js&"
export * from "./IconSvgIdea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d161de",
  null
  
)

export default component.exports